import SignIn from "../modules/SignIn/index";

function SignInPage() {
  return (
    <div>
      <SignIn />
    </div>
  );
}

export default SignInPage;
